import { useBrPageContext } from '../context/context.js';
import { getBrPageContent } from '../utils/get-br-page-content.js';

const useBloomreachReservationBlock = ()=>{
    var ref, ref1;
    const page = useBrPageContext();
    if (!page) {
        return undefined;
    }
    const mainDocumentReference = (ref = page.getComponent('main')) === null || ref === void 0 ? void 0 : ref.getModels().document;
    if (!mainDocumentReference) {
        return undefined;
    }
    if (!mainDocumentReference.$ref) {
        return undefined;
    }
    const reservationDocumentReference = (ref1 = getBrPageContent(page, mainDocumentReference)) === null || ref1 === void 0 ? void 0 : ref1.reservationDocument;
    if (!reservationDocumentReference) {
        return undefined;
    }
    const nextStepsWithBRProperties = getBrPageContent(page, reservationDocumentReference);
    // Bloomreach appends lots of BR properties to the content, so we need to get only what we need
    const { title: title1 , reservationBlock: reservationBlockWithBRProperties  } = nextStepsWithBRProperties || {};
    const reservationBlock = reservationBlockWithBRProperties === null || reservationBlockWithBRProperties === void 0 ? void 0 : reservationBlockWithBRProperties.map((block)=>{
        const { title , icon , text  } = block;
        return {
            title,
            icon,
            text
        };
    });
    return {
        title: title1,
        reservationBlock
    };
};

export { useBloomreachReservationBlock };
//# sourceMappingURL=use-bloomreach-reservation-block.js.map
